<template>
  <div>
    <v-select
        v-if="!readonly && !!item && !!item.component_uid && !!storeAggregate && !!storeAggregate.rootData[item.component_uid]"
        v-model="item.supply_type"
        :items="storeAggregate.rootData[item.component_uid].enabled_supply_types"
        hide-details
        dense
        small-chips
        class="mt-0"
        :readonly="readonly"
    >
      <template v-slot:selection="{item}">
        <v-chip :color="supplyColor(item)">
          {{ item }}
        </v-chip>
      </template>
    </v-select>
    <v-chip
        v-if="!!readonly && !!item && !!item.component_uid && !!storeAggregate && !!storeAggregate.rootData[item.component_uid]"
        :color="supplyColor(item.supply_type)"
        :small="small"
        @click="$emit('click', $event)"
    >
      <slot name="view" :item="item">
        {{ item.supply_type }}
      </slot>
    </v-chip>
  </div>

</template>

<script>

import {useAggregateStore} from "@/store/CommonStore/baseAggregateStore";

export default {
  name: 'ChoiceSupplyType',
  inheritAttrs: false,
  props: {
    item: {default: null},
    readonly: {default: false},
    small: {default: false},
  },

  components: {},

  computed: {},

  methods: {
    supplyColor(supply_type) {
      let supply_color = {
        'Tape and reel': 'orange lighten-4',
        'Tray': 'lime lighten-4',
        'Stick': 'green lighten-4',
        'Bulk': 'blue lighten-4',
      }
      return supply_color[supply_type]
    },
  },

  async mounted() {
    this.storeAggregate = useAggregateStore()
  },

  data() {
    return {
      storeAggregate: null,
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
